import { parseQuery } from '@chilipiper/utils'
import moment from 'moment-timezone'

class AutoBook {
  constructor() {
    const query = parseQuery()

    this.date = String(query.date)
    this.time = !query.time ? '0:00pm' : String(query.time)
    this.zone = !query.zone ? 'UTC' : String(query.zone)
    this.seriesId = query.seriesId !== undefined

    this.dateTime = moment(`${this.date} ${this.time}a ${this.zone}`, 'YYYY-MM-DD HH:mm Z')
  }

  shouldAutoBook() {
    return (this.seriesId || this.date) && this.dateTime && this.dateTime.isValid()
  }
}

export default AutoBook
